module.exports = __webpack_public_path__ + "media/img/home/img_baby-shower-d8e46bff4fc9f522aab96038766cd87e.png";